import { render, staticRenderFns } from "./SchoolSubjectSelect.vue?vue&type=template&id=778b7780&"
import script from "./SchoolSubjectSelect.vue?vue&type=script&lang=js&"
export * from "./SchoolSubjectSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports